var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIncludewebimage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14731_236927)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98122 5.63476H6.83356V6.50586H5.98122V5.63476ZM5.36091 9.15273H8.61559V12.2406H12.1222V6.90469C12.1222 6.88984 12.1238 6.87578 12.1265 6.86172L7.01091 3.11797L1.78786 6.86367C1.79294 6.88203 1.79567 6.90156 1.79567 6.92148V12.2406H5.36091V9.15273ZM12.6855 12.5801C12.6855 12.7035 12.5855 12.8039 12.4613 12.8039H1.45622C1.33239 12.8039 1.232 12.7035 1.232 12.5801V7.15469C0.083171 7.59687 -0.34222 6.18281 0.299577 5.67734L6.81911 0.910546C6.89841 0.83789 7.02067 0.830468 7.10817 0.898827L13.6418 5.65547C13.6414 5.65625 13.666 5.67734 13.6683 5.68008C14.4418 6.51289 13.6265 7.61289 12.6855 7.16875V12.5801ZM13.4929 9.15273H14.3945V12.3211H18.4609V7.21601C18.4609 7.19922 18.4632 7.18242 18.4672 7.1668L13.9906 3.95625L13.3336 4.43711L11.9836 3.4543L13.907 2.05391C13.9428 2.02598 13.9873 2.01167 14.0327 2.01353C14.078 2.01539 14.1213 2.0333 14.1547 2.06406L17.664 4.62969V3.39883H19.1914V5.74648L19.7433 6.15C20.2914 6.57578 19.9328 7.79687 18.9441 7.41601V12.6121C18.9441 12.718 18.8578 12.8039 18.7519 12.8039H13.4683L13.4929 12.5801V9.15273ZM7.99489 6.79609H7.14294V7.66719H7.99489V6.79609ZM5.98122 6.79609H6.83356V7.66719H5.98122V6.79609ZM7.99489 5.63476H7.14294V6.50586H7.99489V5.63476Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14731_236927"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 11.9523,
    fill: "white",
    transform: "translate(0 0.851562)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncludewebimage);
export default __webpack_public_path__ + "static/media/includewebimage.9ac18cef4b50ddc8862811629b243218.svg";
export { ForwardRef as ReactComponent };